import { setContext, ContextSetter } from 'apollo-link-context';
import VueCookie from 'vue-cookie';
import { createQueryAndMutateFunctions } from './common';
import { ENDPOINTS } from '@/settings/endpoints';

export const chimeraAuth: ContextSetter = (_, { headers }) => {
  const dCookie = VueCookie.get('d', { domain: '.descomplica.com.br' });

  if (dCookie) {
    return {
      headers: {
        ...headers,
        authorization: `Bearer ${dCookie.replace(/"/g, '')}`,
      },
    };
  }
  return headers;
};

const chimeraAuthLink = setContext(chimeraAuth);

export const { query: chimeraQuery, mutate: chimeraMutation } = createQueryAndMutateFunctions(
  ENDPOINTS.chimera,
  chimeraAuthLink,
);
